import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import SignatureCanvas from 'react-signature-canvas';
import PropTypes from 'prop-types';
import useDebounce from './../../cmp/hooks/useDebounce';
import {InputIcon, PencilIcon, TrashIcon} from '../../../icons/Icons';
import Input from './Input';
import {useIntl} from 'react-intl';
import useToggle from '../hooks/useToggle';

function SignatureInput({onChange}) {
    const changed = useCallback((value)=>{
      onChange({
        target:{
          value,
          dataURL: value,
        }
      })
    },[onChange])
     return (<>
             <SignatureInputModal updateSignature={changed} />
         </>
    );
}

function SignatureInputModal({updateSignature}){
  const [value, setValue] = useState()
  const signatureCanvasRef = useRef()
  const clearCanvas = useCallback(() => {
    signatureCanvasRef.current.fromData([]);
    setValue(null)
  },[signatureCanvasRef])
  useEffect(()=>{
    if(signatureCanvasRef && signatureCanvasRef.current){
      signatureCanvasRef.current.fromDataURL(value)
    }
  }, [value, signatureCanvasRef])
  useEffect(()=>{
    updateSignature(value ? signatureCanvasRef.current.getTrimmedCanvas().toDataURL('image/png') : null)
  },[value])
  const [isSignature, toggleSignature] = useToggle(true)
  const width = useMemo(()=>{
    return 350
  },[])

  return  <div className="border rounded shadow-sm position-relative" style={{width}}>
        {
            !isSignature ?   <RenderHandwritingInput onChange={updateSignature} width={width}/> :
                <>
              <SignatureCanvas
                  onEnd={setValue} ref={signatureCanvasRef}
                  penColor="#2980b9"
                  canvasProps={{width, height: 200, className: 'sigCanvas'}}
              />
              </>
        }
          <div style={{position: 'absolute', top:0, right:0}} className={"d-flex flex-column"}>
            <button type={"button"}
                    className={" btn btn-link "}
                    onClick={toggleSignature}>{
                    isSignature ? <InputIcon /> : <PencilIcon />
              }
            </button>
            {value ?
                <button type={"button"}
                        className={"btn btn-link text-danger"}
                        onClick={clearCanvas}><TrashIcon/></button> : null
            }
          </div>
    </div>
}

SignatureInput.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.array,
}

function RenderHandwritingInput({width, onChange}){
  const [text, setText]= useState('')
  const [dataURL, setDataUrl] = useState('');
  const _dataURL = useDebounce(dataURL, 300);
  useEffect(()=>{
    onChange(_dataURL)
  },[_dataURL])
  const intl = useIntl()
  return <div>
    <RenderHandwritingCanvas value={text} width={width} onChange={setDataUrl} />
    <Input value={text} placeholder={intl.formatMessage({id:'yourName'})} onChange={setText} />
  </div>
}

function RenderHandwritingCanvas({value,width, onChange}){
    const canvasRef = useRef(null)
    const hiddenCanvas = useRef(null)
    useEffect(()=> {
      if(canvasRef && canvasRef.current) {
        const canvas = canvasRef.current
        drawOnCanvas(canvas, value, width)
      }
    },[canvasRef,width,  value])

    const debouncedVal = useDebounce(value, 300);
    useEffect(()=>{
      if(hiddenCanvas && hiddenCanvas.current) {
        const canvas = hiddenCanvas.current
        if(canvas) {
          if (debouncedVal) {
            drawOnCanvas(canvas, debouncedVal, width);
            onChange(cropImageFromCanvas(canvas.getContext('2d')))
          } else {
            onChange(debouncedVal)
          }
        }
      }
    },[debouncedVal, width, hiddenCanvas])

    useEffect(()=>{
         new FontFace('SignatureFont', 'url(/signaturefonts/GreatVibes-Regular.ttf)').load().then((font)=>document.fonts.add(font));

//      new FontFace('SignatureFont', 'url(/signaturefonts/Lobster-Regular.ttf)').load().then((font)=>document.fonts.add(font));
    }, [])

    return <>
      <canvas ref={canvasRef} />
      <canvas ref={hiddenCanvas} style={{display:'none'}} />
    </>
}



function drawOnCanvas(canvas, value, width){
  const ctx = canvas.getContext('2d')
  const height = 100;
  var scale = window.devicePixelRatio;
  canvas.style.width = width + "px";
  canvas.style.height = height + "px";
  canvas.width = Math.floor(width * scale);
  canvas.height = Math.floor(height * scale);
  ctx.fillStyle = "#2980b9";
  ctx.scale(scale, scale);
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.font = "40px SignatureFont";
  ctx.textAlign = "center";
  ctx.textBaseline = 'middle';
  var x = width / 2;
  var y = height / 2;
  ctx.fillText(value || '', x, y);
}

function cropImageFromCanvas(ctx) {
  var canvas = ctx.canvas,
      w = canvas.width, h = canvas.height,
      pix = {x:[], y:[]},
      imageData = ctx.getImageData(0,0,canvas.width,canvas.height),
      x, y, index;

  for (y = 0; y < h; y++) {
    for (x = 0; x < w; x++) {
      index = (y * w + x) * 4;
      if (imageData.data[index+3] > 0) {
        pix.x.push(x);
        pix.y.push(y);
      }
    }
  }
  pix.x.sort(function(a,b){return a-b});
  pix.y.sort(function(a,b){return a-b});
  var n = pix.x.length-1;

  w = 1 + pix.x[n] - pix.x[0];
  h = 1 + pix.y[n] - pix.y[0];
  var cut = ctx.getImageData(pix.x[0], pix.y[0], w, h);

  canvas.width = w;
  canvas.height = h;
  ctx.putImageData(cut, 0, 0);
  return canvas.toDataURL("image/png");
}


export default SignatureInput;
